
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

(function () {
    'use strict';

    angular.module('app').factory('webApiServices', ApiFactory);

    ApiFactory.$inject = ['$http', 'settingsService','FileUploader',];
    function ApiFactory($http, settingsService,FileUploader) {

        function applyCallbacks(promise, successCallback, errorCallback, finallyCallback) {
            return promise
                .then(successCallback, errorCallback)
                .finally(finallyCallback);
        }

        function buildUrl(route, parameters) {
            const baseUrl = `${settingsService.applicationPath}${route}`;
            if (!parameters)
                return baseUrl;
            else
                return `${baseUrl}?${parameters}`;
        }

        
        const AcceptFvmEdit = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmEdit/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptFvmEditNoAction = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmEditNoAction/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptFvmEditWithoutScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmEditWithoutScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptFvmPhase1 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmPhase1/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptFvmPhase2 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmPhase2/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptFvmPhase2WithoutScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptFvmPhase2WithoutScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptIvm = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptIvm/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptIvmForeign = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptIvmForeign/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptPscRequestAndIssueTempClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptPscRequestAndIssueTempClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptPscRequestWithForeignClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptPscRequestWithForeignClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptPscRequestWithoutScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptPscRequestWithoutScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcceptSecurityOfficerApplication = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcceptSecurityOfficerApplication/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcknowledgeFvmRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcknowledgeFvmRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcknowledgeJustificationRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcknowledgeJustificationRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcknowledgePersonRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcknowledgePersonRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AcknowledgeRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AcknowledgeRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ActivateAgenda = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ActivateAgenda/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ActivateDeactivateClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ActivateDeactivateClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ActivateImportedDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ActivateImportedDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ActivateSelectedDossiers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ActivateSelectedDossiers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AddCertifOutPartialScreeningForRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AddCertifOutPartialScreeningForRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AddClearanceToCompanyDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AddClearanceToCompanyDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AddGovernmentJustification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AddGovernmentJustification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AddJustification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AddJustification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AddOrUpdateInvoiceAddress = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AddOrUpdateInvoiceAddress/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AgendaExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AgendaExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ApproveStopFvmScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ApproveStopFvmScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ApproveStopPsc = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ApproveStopPsc/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AskAllFvmScreeningsToStop = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AskAllFvmScreeningsToStop/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AskToStopDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AskToStopDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const AssignDossierManager = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/AssignDossierManager/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const BlockDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/BlockDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CancelFvmScreeningsToStop = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CancelFvmScreeningsToStop/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CancelStopDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CancelStopDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CancelSuspendedPersonSecurityClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CancelSuspendedPersonSecurityClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeAllowedNumberOfSecurityOfficers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeAllowedNumberOfSecurityOfficers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeAttachmentType = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeAttachmentType/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeClearanceDate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeClearanceDate/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeDossierLanguage = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeDossierLanguage/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeDossierLanguageByRequestId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeDossierLanguageByRequestId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeDossierNeedsPaying = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeDossierNeedsPaying/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeInvoiceMarkedAsPaid = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeInvoiceMarkedAsPaid/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeJustificationType = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeJustificationType/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeNuclearNeeded = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeNuclearNeeded/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeOrganisationNameSAN = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeOrganisationNameSAN/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeScreeningByOnDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeScreeningByOnDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ChangeScreeningResultToSecurityCheck = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ChangeScreeningResultToSecurityCheck/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CompareJustificationLists = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CompareJustificationLists/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateAssistantSecurityOfficer = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateAssistantSecurityOfficer/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateIVMFromFVM = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateIVMFromFVM/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateOrUpdateContactFormTopic = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateOrUpdateContactFormTopic/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateOrUpdateInvoiceFee = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateOrUpdateInvoiceFee/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateOrUpdateNewsItem = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateOrUpdateNewsItem/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateOrUpdateWebinarEventItem = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateOrUpdateWebinarEventItem/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateSecurityOfficerApplication = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateSecurityOfficerApplication/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateUpdateScreeningFVMRemarkActivity = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateUpdateScreeningFVMRemarkActivity/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateUpdateScreeningFVMRemarkIdentity = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateUpdateScreeningFVMRemarkIdentity/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateUpdateScreeningFVMRemarkJustification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateUpdateScreeningFVMRemarkJustification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateUpdateScreeningFVMRemarkPerson = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateUpdateScreeningFVMRemarkPerson/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const CreateUpdateScreeningFVMRemarkRelations = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/CreateUpdateScreeningFVMRemarkRelations/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteApplicationUserByUserName = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteApplicationUserByUserName/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteAttachment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteAttachment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteContactFormTopicByPublicId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteContactFormTopicByPublicId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteEntireDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteEntireDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteFscRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteFscRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteFvmPerson = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteFvmPerson/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteHabilBVLById = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteHabilBVLById/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteImportedDossiers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteImportedDossiers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteInvoiceById = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteInvoiceById/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteInvoiceFee = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteInvoiceFee/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteJustificationAttachment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteJustificationAttachment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteNewsItemByPublicId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteNewsItemByPublicId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteNotification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteNotification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeletePartner = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeletePartner/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeletePdfFileByName = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeletePdfFileByName/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteScreeningAttachment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteScreeningAttachment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteSecurityOfficer = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteSecurityOfficer/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteSubContractors = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteSubContractors/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteUsers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteUsers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteVideoFileByName = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteVideoFileByName/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteVMByEmailRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteVMByEmailRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DeleteWebinarEventItemByPublicId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DeleteWebinarEventItemByPublicId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DequeueIvmRequestStateChange = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DequeueIvmRequestStateChange/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DoCreateSubContractor = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DoCreateSubContractor/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DoCreateVMByEmailRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DoCreateVMByEmailRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DoResendVMByEmailRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DoResendVMByEmailRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DoUpdateSubContractor = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DoUpdateSubContractor/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DownloadAgenda = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/DownloadAgenda/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const DownloadSubscriberList = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DownloadSubscriberList/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const DownloadWordTemplate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/DownloadWordTemplate/invoke', urlParameters),
                data: data,
                responseType: 'arraybuffer',
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const EnrichFromCBE = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/EnrichFromCBE/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const EnterScreeningResult = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/EnterScreeningResult/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ExecuteStateChangeQueue = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ExecuteStateChangeQueue/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ExportExcelResx = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ExportExcelResx/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ExtendAutoDeleteDate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ExtendAutoDeleteDate/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ExtendClearanceByXMonths = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ExtendClearanceByXMonths/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ExtendLoginCreds = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ExtendLoginCreds/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FscScreeningsExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FscScreeningsExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FvmRequestAcceptedAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FvmRequestAcceptedAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FvmRequestAcceptedWithLimitationAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FvmRequestAcceptedWithLimitationAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FvmRequestRefusedAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FvmRequestRefusedAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FVMSavePhase1 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FVMSavePhase1/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const FVMSavePhase2 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/FVMSavePhase2/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GenerateBVLPdf = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GenerateBVLPdf/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAction = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetAction/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetActions = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetActions/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetActiveWebinarEventItemsByLanguage = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetActiveWebinarEventItemsByLanguage/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAgendasByFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAgendasByFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllCodesByLanguage = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllCodesByLanguage/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllDossierComments = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllDossierComments/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllNewsItems = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllNewsItems/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllPersonsWithValidClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllPersonsWithValidClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllReports = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetAllReports/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetAllRequestComments = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllRequestComments/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllScreeningRemarksByFvm = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllScreeningRemarksByFvm/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllScreeningsForFvmRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllScreeningsForFvmRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllSoUsersByDossierOrganisationId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllSoUsersByDossierOrganisationId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAllSubContractors = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetAllSubContractors/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetAllTranslations = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAllTranslations/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAppointSecurityOfficerDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetAppointSecurityOfficerDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetAssistOutLettersForRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetAssistOutLettersForRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetAssistOutStopLetterForScreening = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetAssistOutStopLetterForScreening/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetAttachmentByPublicId = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetAttachmentByPublicId/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetBelgianScreeningPartners = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetBelgianScreeningPartners/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetBoardMembers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetBoardMembers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetBranches = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetBranches/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetBVL = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetBVL/invoke', urlParameters),
                data: data,
                responseType: 'arraybuffer',
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetCertificate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetCertificate/invoke', urlParameters),
                data: data,
                responseType: 'arraybuffer',
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetCertifOutStopLetterForScreening = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetCertifOutStopLetterForScreening/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetClearanceOverviewPaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetClearanceOverviewPaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetClearancesBySo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetClearancesBySo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetClearancesExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetClearancesExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetClearanceVMByEmailOverview = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetClearanceVMByEmailOverview/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetContactFormTopicForEdit = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetContactFormTopicForEdit/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetContactFormTopicsOverviewPaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetContactFormTopicsOverviewPaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetCreditnoteAtt = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetCreditnoteAtt/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetDossierByKboNumber = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossierByKboNumber/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetDossierInformation = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossierInformation/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetDossierInvoices = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossierInvoices/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetDossierManagers = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossierManagers/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetDossiersExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossiersExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetDossiersWithoutAnnualReportExport = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetDossiersWithoutAnnualReportExport/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetExclusivityDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetExclusivityDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetExplanatoryNoteTerms = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetExplanatoryNoteTerms/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetFSCISDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetFSCISDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetFunctionalCode = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFunctionalCode/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFunctionalCodesPaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFunctionalCodesPaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFvmByScreeningId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFvmByScreeningId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFVMEdit = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFVMEdit/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFvmEditByScreeningId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFvmEditByScreeningId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFVMPhase1 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFVMPhase1/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFvmPhase1SignaturesByUser = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFvmPhase1SignaturesByUser/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFVMPhase2 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFVMPhase2/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFvmRequestResult = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFvmRequestResult/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFVMRequestsExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFVMRequestsExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetFvmScreeningsToStop = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetFvmScreeningsToStop/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetHomologationJustifications = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetHomologationJustifications/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetInvalidSubcontractorJustifications = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetInvalidSubcontractorJustifications/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetInvoiceAddress = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetInvoiceAddress/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetInvoiceFee = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetInvoiceFee/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetInvoicePdf = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetInvoicePdf/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetInvoicesFeeByFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetInvoicesFeeByFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMAcknowledgementModel = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMAcknowledgementModel/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMRequestPhase2 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMRequestPhase2/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMRequestPhase4 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMRequestPhase4/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMRequestPhase5 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMRequestPhase5/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIvmRequestResult = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIvmRequestResult/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMRequestsExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMRequestsExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMScreeningRemarks = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMScreeningRemarks/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetIVMSecurityBriefingModel = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetIVMSecurityBriefingModel/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetLoggingByFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetLoggingByFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetLoggingTotalsByFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetLoggingTotalsByFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetMainContractorNameByKBONumber = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetMainContractorNameByKBONumber/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetManageUsersButtonStates = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetManageUsersButtonStates/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetNewIVMPhase1FromFVM = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetNewIVMPhase1FromFVM/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetNewsItemsByAppsAndRoles = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetNewsItemsByAppsAndRoles/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetNoAcknowledgementDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetNoAcknowledgementDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetNotifications = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetNotifications/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetNsaSecurityAwarenessBriefing = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetNsaSecurityAwarenessBriefing/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetOrganisationDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetOrganisationDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetOrganisationsByKboNumberOrName = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetOrganisationsByKboNumberOrName/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetOrganisationsToLinkSubContractor = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetOrganisationsToLinkSubContractor/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetOrganisationSubContractors = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetOrganisationSubContractors/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetParameter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetParameter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPartner = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPartner/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPartnerByCodeAndType = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPartnerByCodeAndType/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPartnerCodes = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetPartnerCodes/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetPartners = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPartners/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPaymentMailSamples = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPaymentMailSamples/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPdfFiles = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetPdfFiles/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetPhaseFile = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetPhaseFile/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetPhaseFilesSetAccepted = function(data, urlParameters) {
            let url = `${settingsService.applicationPath}api/GetPhaseFilesSetAccepted/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'post',
                url: url,
                data: data,
                responseType: 'arraybuffer',
            });
        };
            
        const GetPrivateTopicsInUserLanguage = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPrivateTopicsInUserLanguage/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPscBriefingData = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPscBriefingData/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetPscisDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetPscisDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetPublicNewsItemsByApps = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetPublicNewsItemsByApps/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetRegistrationDocument = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetRegistrationDocument/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetRemarksForPscRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetRemarksForPscRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetReportById = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetReportById/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetReportByIdAndFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetReportByIdAndFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetRequestFvmPersonForCurrentUser = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetRequestFvmPersonForCurrentUser/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetRequestHistory = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetRequestHistory/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetRequestIvmsWithOngoingScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetRequestIvmsWithOngoingScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetResultLetterForRequestByPartner = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetResultLetterForRequestByPartner/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetScreeningAttachments = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetScreeningAttachments/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetScreeningGroupByFvmId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetScreeningGroupByFvmId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetScreeningsToStop = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetScreeningsToStop/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSecurityOfficerApplicationDetail = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSecurityOfficerApplicationDetail/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSecurityOfficerApplications = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSecurityOfficerApplications/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSecurityOfficersAndBoardmembersByOrganisationId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSecurityOfficersAndBoardmembersByOrganisationId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSendToInvolvedWhenIvmIsCompletedMailBody = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSendToInvolvedWhenIvmIsCompletedMailBody/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSessionTrace = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSessionTrace/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetStoppedScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetStoppedScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSubContractorAlreadyExists = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSubContractorAlreadyExists/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetSummaryForRelation = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetSummaryForRelation/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetTranslationPhrasesPaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetTranslationPhrasesPaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetTranslationsByLanguage = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetTranslationsByLanguage/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetUsersByRoleExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetUsersByRoleExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetUsersByRolePaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetUsersByRolePaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetVideoFiles = function(successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'get',
                url: buildUrl('api/GetVideoFiles/invoke', urlParameters),
                
            });

            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);                                    
        };
                    
        const GetVoDashboardInfo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetVoDashboardInfo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetWebinarEventItemOverviewByFilter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetWebinarEventItemOverviewByFilter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetWordTemplate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetWordTemplate/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const GetWordTemplateFiles = function(urlParameters) {
            let url = `${settingsService.applicationPath}api/GetWordTemplateFiles/invoke`;
            url += (urlParameters)?`?${urlParameters}` : ``;
            return $http({
                method: 'get',
                url: url,
                
                responseType: 'arraybuffer',
            });
        };
            
        const GetWordTemplateTypes = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/GetWordTemplateTypes/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const InvalidateJustification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/InvalidateJustification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const InviteRelation = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/InviteRelation/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const IsDocumentNoAcknowledgementAlreadySigned = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/IsDocumentNoAcknowledgementAlreadySigned/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const IvmRequestAcceptedAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/IvmRequestAcceptedAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const IvmRequestAcceptedWithLimitationAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/IvmRequestAcceptedWithLimitationAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const IvmRequestRefusedAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/IvmRequestRefusedAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ListFunctionalCodes = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ListFunctionalCodes/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const LoadFromKBO = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/LoadFromKBO/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const MarkRequestAsRenewal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/MarkRequestAsRenewal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const MarkUserAsPreferredSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/MarkUserAsPreferredSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ProceedWithStopDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ProceedWithStopDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ProcessAcceptTerms = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ProcessAcceptTerms/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const PscRequestAdministrativelyRefusedAfterAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/PscRequestAdministrativelyRefusedAfterAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RecallFVM = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RecallFVM/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RecallIvmByPublicIdAndScreeningId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RecallIvmByPublicIdAndScreeningId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RefuseStopPsc = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RefuseStopPsc/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RefuseTerms = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RefuseTerms/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RefuseVMByEmailRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RefuseVMByEmailRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RejectSecurityOfficerApplication = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RejectSecurityOfficerApplication/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RemoveFvmOnHold = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RemoveFvmOnHold/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RemoveJustification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RemoveJustification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RemoveSignaturesOnUpdateAfterInvitationWasSend = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RemoveSignaturesOnUpdateAfterInvitationWasSend/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReopenIvmScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReopenIvmScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReopenScreeningById = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReopenScreeningById/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReopenScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReopenScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReplyOnNotification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReplyOnNotification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RequestCreditNoteAndInvalidate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RequestCreditNoteAndInvalidate/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RequestCreditNoteForInvoice = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RequestCreditNoteForInvoice/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RequestCreditNoteForInvoiceLine = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RequestCreditNoteForInvoiceLine/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ResendLoginCreds = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ResendLoginCreds/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ResetFvmPersonAction = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ResetFvmPersonAction/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ResetJustificationAction = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ResetJustificationAction/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReturnFvmToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReturnFvmToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ReturnIvmToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ReturnIvmToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const RevokePersonSecurityClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/RevokePersonSecurityClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveAction = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveAction/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveBaseRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveBaseRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveDossierComment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveDossierComment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveExternalSubscriberToEventItem = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveExternalSubscriberToEventItem/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveFscPersonRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveFscPersonRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveFunctionalCode = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveFunctionalCode/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveFvmEdit = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveFvmEdit/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveFvmPerson = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveFvmPerson/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIvmRangeAction = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIvmRangeAction/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIvmRangeRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIvmRangeRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIVMRequestPhase2 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIVMRequestPhase2/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIVMRequestPhase4 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIVMRequestPhase4/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIVMRequestPhase5 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIVMRequestPhase5/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveIVMScreeningRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveIVMScreeningRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveJustificationRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveJustificationRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveNoAcknowledgement = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveNoAcknowledgement/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveOrCreateTranslationPhrase = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveOrCreateTranslationPhrase/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveParameter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveParameter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SavePartner = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SavePartner/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveRequestComment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveRequestComment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveRequestRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveRequestRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveSecurityIncidentComment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveSecurityIncidentComment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SaveSubjectPersonRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SaveSubjectPersonRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const ScreeningsExporting = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/ScreeningsExporting/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchCreditNotes = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchCreditNotes/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchDossierPaged = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchDossierPaged/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchFVMRequests = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchFVMRequests/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchFvmScreeningsToStop = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchFvmScreeningsToStop/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchInvoices = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchInvoices/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchIVMRequests = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchIVMRequests/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchMyFvmScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchMyFvmScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchMyPagedScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchMyPagedScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchParameters = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchParameters/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchRegisteredCompanies = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchRegisteredCompanies/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchScreeningsPerOrganisation = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchScreeningsPerOrganisation/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SearchStateChangesToConfirm = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SearchStateChangesToConfirm/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SelectSigningBoardMember = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SelectSigningBoardMember/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SelectSigningSecurityOfficer = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SelectSigningSecurityOfficer/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendAcceptedVMByEmailRequestToVo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendAcceptedVMByEmailRequestToVo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendAssistanceInResultLetter = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendAssistanceInResultLetter/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendClearanceDeactivationToNsa = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendClearanceDeactivationToNsa/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmBackToPhase1 = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmBackToPhase1/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmEditBackToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmEditBackToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmEditToNvo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmEditToNvo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmPhase1BackToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmPhase1BackToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmPhase1SignatureInvitationMail = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmPhase1SignatureInvitationMail/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmPhase1ToNvo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmPhase1ToNvo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmPhase2BackToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmPhase2BackToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendFvmPhase2ToNvo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendFvmPhase2ToNvo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendInvestigationImpossibleEmail = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendInvestigationImpossibleEmail/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendInvitationToSignNoAcknowledgementDocument = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendInvitationToSignNoAcknowledgementDocument/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendInvitationToSignTemporaryNoAcknowledgementDocument = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendInvitationToSignTemporaryNoAcknowledgementDocument/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendIvmBackInvalidByCol = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendIvmBackInvalidByCol/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendIvmBackInvalidByNvo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendIvmBackInvalidByNvo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendIvmRequestBackToInvolved = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendIvmRequestBackToInvolved/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendMail = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendMail/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendNewsItemByPublicId = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendNewsItemByPublicId/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendNoAcknowledgementDocument = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendNoAcknowledgementDocument/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendReminderForInvoice = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendReminderForInvoice/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendReminderMailForAssistOutRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendReminderMailForAssistOutRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendReminderMailForCertifOutRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendReminderMailForCertifOutRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SendStopScreeningToNsa = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SendStopScreeningToNsa/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetActionCodeForPerson = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetActionCodeForPerson/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetExternalSubscriberAttendance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetExternalSubscriberAttendance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetForeignState = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetForeignState/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetFvmAppealed = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetFvmAppealed/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetFvmOnHold = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetFvmOnHold/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetFvmPersonNoAckJustificationsAndRemark = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetFvmPersonNoAckJustificationsAndRemark/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetFvmRequestBackToNsa = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetFvmRequestBackToNsa/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetFvmSignatureByUser = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetFvmSignatureByUser/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmAppealed = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmAppealed/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmAppealedDecisionOutOfTerm = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmAppealedDecisionOutOfTerm/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmNeedsToBeInvoiced = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmNeedsToBeInvoiced/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmOnHold = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmOnHold/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmRequestBackToNsa = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmRequestBackToNsa/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetIvmRequestDeleted = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetIvmRequestDeleted/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetPscRequestBackToSo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetPscRequestBackToSo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetReadStateOnNotification = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetReadStateOnNotification/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetRelatedCompanyExplanationAcceptedAndReason = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetRelatedCompanyExplanationAcceptedAndReason/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetRequireAdditionalDocuments = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetRequireAdditionalDocuments/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetSignedBvlsSeenBySo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetSignedBvlsSeenBySo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SetSubscriberAttendance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SetSubscriberAttendance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StartForeignPartialScreeningForRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StartForeignPartialScreeningForRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StartFvmEdit = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StartFvmEdit/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StartFVMRenewal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StartFVMRenewal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StopFvmScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StopFvmScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StopPartialScreening = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StopPartialScreening/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StopScreenings = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StopScreenings/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const StopSecurityOfficerApplication = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/StopSecurityOfficerApplication/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubmitIVMAcknowledgementSignature = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubmitIVMAcknowledgementSignature/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubmitIVMSecurityBriefingSignature = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubmitIVMSecurityBriefingSignature/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubmitPrivateContactFormToNvo = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubmitPrivateContactFormToNvo/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubmitRegistrationToNsa = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubmitRegistrationToNsa/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubmitRelationSignature = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubmitRelationSignature/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SubscribeToEventItem = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SubscribeToEventItem/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const SuspendPersonSecurityClearance = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/SuspendPersonSecurityClearance/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UnblockDossier = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UnblockDossier/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UnsubscribeEventItem = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UnsubscribeEventItem/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UnsubscribeExternalSubscriber = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UnsubscribeExternalSubscriber/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateBVL = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateBVL/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateDossierRemarks = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateDossierRemarks/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateForeignIVMClearancePdf = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateForeignIVMClearancePdf/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateGovernmentAddresses = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateGovernmentAddresses/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateImportedSecurityOfficer = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateImportedSecurityOfficer/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdateOrganisationType = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdateOrganisationType/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UpdatePersonSecurityClearanceDate = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UpdatePersonSecurityClearanceDate/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UploadAnnualReport = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UploadAnnualReport/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UploadAttachmentsForRequest = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UploadAttachmentsForRequest/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UploadDossierCommentAttachment = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadDossierCommentAttachment/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadExcelResx = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadExcelResx/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadHabilBVL = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadHabilBVL/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadJustificationAttachment = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UploadJustificationAttachment/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UploadPaymentFile = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadPaymentFile/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadPdfFile = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadPdfFile/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadRequestCommentAttachment = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadRequestCommentAttachment/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadScreeningResults = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadScreeningResults/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadTemporaryNoAcknowledgementDocument = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/UploadTemporaryNoAcknowledgementDocument/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const UploadUpdateFiles = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadUpdateFiles/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadVideoFile = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadVideoFile/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const UploadWordTemplate = new FileUploader({
            url: `${settingsService.applicationPath}api/UploadWordTemplate/invoke`,
            removeAfterUpload: true,
            queueLimit: 10
        });
                    
        const WithdrawFvmAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/WithdrawFvmAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        
        const WithdrawIvmAppeal = function(data, successCallback, errorCallback, finallyCallback, urlParameters) {
            const httprequest = $http({
                method: 'post',
                url: buildUrl('api/WithdrawIvmAppeal/invoke', urlParameters),
                data: data,
                
            });
                
            applyCallbacks(httprequest, successCallback, errorCallback, finallyCallback);
        };
                        

        return {
                        AcceptFvmEdit: AcceptFvmEdit,
            AcceptFvmEditNoAction: AcceptFvmEditNoAction,
            AcceptFvmEditWithoutScreening: AcceptFvmEditWithoutScreening,
            AcceptFvmPhase1: AcceptFvmPhase1,
            AcceptFvmPhase2: AcceptFvmPhase2,
            AcceptFvmPhase2WithoutScreening: AcceptFvmPhase2WithoutScreening,
            AcceptIvm: AcceptIvm,
            AcceptIvmForeign: AcceptIvmForeign,
            AcceptPscRequestAndIssueTempClearance: AcceptPscRequestAndIssueTempClearance,
            AcceptPscRequestWithForeignClearance: AcceptPscRequestWithForeignClearance,
            AcceptPscRequestWithoutScreening: AcceptPscRequestWithoutScreening,
            AcceptSecurityOfficerApplication: AcceptSecurityOfficerApplication,
            AcknowledgeFvmRemark: AcknowledgeFvmRemark,
            AcknowledgeJustificationRemark: AcknowledgeJustificationRemark,
            AcknowledgePersonRemark: AcknowledgePersonRemark,
            AcknowledgeRemark: AcknowledgeRemark,
            ActivateAgenda: ActivateAgenda,
            ActivateDeactivateClearance: ActivateDeactivateClearance,
            ActivateImportedDossier: ActivateImportedDossier,
            ActivateSelectedDossiers: ActivateSelectedDossiers,
            AddCertifOutPartialScreeningForRequest: AddCertifOutPartialScreeningForRequest,
            AddClearanceToCompanyDossier: AddClearanceToCompanyDossier,
            AddGovernmentJustification: AddGovernmentJustification,
            AddJustification: AddJustification,
            AddOrUpdateInvoiceAddress: AddOrUpdateInvoiceAddress,
            AgendaExporting: AgendaExporting,
            ApproveStopFvmScreenings: ApproveStopFvmScreenings,
            ApproveStopPsc: ApproveStopPsc,
            AskAllFvmScreeningsToStop: AskAllFvmScreeningsToStop,
            AskToStopDossier: AskToStopDossier,
            AssignDossierManager: AssignDossierManager,
            BlockDossier: BlockDossier,
            CancelFvmScreeningsToStop: CancelFvmScreeningsToStop,
            CancelStopDossier: CancelStopDossier,
            CancelSuspendedPersonSecurityClearance: CancelSuspendedPersonSecurityClearance,
            ChangeAllowedNumberOfSecurityOfficers: ChangeAllowedNumberOfSecurityOfficers,
            ChangeAttachmentType: ChangeAttachmentType,
            ChangeClearanceDate: ChangeClearanceDate,
            ChangeDossierLanguage: ChangeDossierLanguage,
            ChangeDossierLanguageByRequestId: ChangeDossierLanguageByRequestId,
            ChangeDossierNeedsPaying: ChangeDossierNeedsPaying,
            ChangeInvoiceMarkedAsPaid: ChangeInvoiceMarkedAsPaid,
            ChangeJustificationType: ChangeJustificationType,
            ChangeNuclearNeeded: ChangeNuclearNeeded,
            ChangeOrganisationNameSAN: ChangeOrganisationNameSAN,
            ChangeScreeningByOnDossier: ChangeScreeningByOnDossier,
            ChangeScreeningResultToSecurityCheck: ChangeScreeningResultToSecurityCheck,
            CompareJustificationLists: CompareJustificationLists,
            CreateAssistantSecurityOfficer: CreateAssistantSecurityOfficer,
            CreateIVMFromFVM: CreateIVMFromFVM,
            CreateOrUpdateContactFormTopic: CreateOrUpdateContactFormTopic,
            CreateOrUpdateInvoiceFee: CreateOrUpdateInvoiceFee,
            CreateOrUpdateNewsItem: CreateOrUpdateNewsItem,
            CreateOrUpdateWebinarEventItem: CreateOrUpdateWebinarEventItem,
            CreateSecurityOfficerApplication: CreateSecurityOfficerApplication,
            CreateUpdateScreeningFVMRemarkActivity: CreateUpdateScreeningFVMRemarkActivity,
            CreateUpdateScreeningFVMRemarkIdentity: CreateUpdateScreeningFVMRemarkIdentity,
            CreateUpdateScreeningFVMRemarkJustification: CreateUpdateScreeningFVMRemarkJustification,
            CreateUpdateScreeningFVMRemarkPerson: CreateUpdateScreeningFVMRemarkPerson,
            CreateUpdateScreeningFVMRemarkRelations: CreateUpdateScreeningFVMRemarkRelations,
            DeleteApplicationUserByUserName: DeleteApplicationUserByUserName,
            DeleteAttachment: DeleteAttachment,
            DeleteContactFormTopicByPublicId: DeleteContactFormTopicByPublicId,
            DeleteEntireDossier: DeleteEntireDossier,
            DeleteFscRequest: DeleteFscRequest,
            DeleteFvmPerson: DeleteFvmPerson,
            DeleteHabilBVLById: DeleteHabilBVLById,
            DeleteImportedDossiers: DeleteImportedDossiers,
            DeleteInvoiceById: DeleteInvoiceById,
            DeleteInvoiceFee: DeleteInvoiceFee,
            DeleteJustificationAttachment: DeleteJustificationAttachment,
            DeleteNewsItemByPublicId: DeleteNewsItemByPublicId,
            DeleteNotification: DeleteNotification,
            DeletePartner: DeletePartner,
            DeletePdfFileByName: DeletePdfFileByName,
            DeleteScreeningAttachment: DeleteScreeningAttachment,
            DeleteSecurityOfficer: DeleteSecurityOfficer,
            DeleteSubContractors: DeleteSubContractors,
            DeleteUsers: DeleteUsers,
            DeleteVideoFileByName: DeleteVideoFileByName,
            DeleteVMByEmailRequest: DeleteVMByEmailRequest,
            DeleteWebinarEventItemByPublicId: DeleteWebinarEventItemByPublicId,
            DequeueIvmRequestStateChange: DequeueIvmRequestStateChange,
            DoCreateSubContractor: DoCreateSubContractor,
            DoCreateVMByEmailRequest: DoCreateVMByEmailRequest,
            DoResendVMByEmailRequest: DoResendVMByEmailRequest,
            DoUpdateSubContractor: DoUpdateSubContractor,
            DownloadAgenda: DownloadAgenda,
            DownloadSubscriberList: DownloadSubscriberList,
            DownloadWordTemplate: DownloadWordTemplate,
            EnrichFromCBE: EnrichFromCBE,
            EnterScreeningResult: EnterScreeningResult,
            ExecuteStateChangeQueue: ExecuteStateChangeQueue,
            ExportExcelResx: ExportExcelResx,
            ExtendAutoDeleteDate: ExtendAutoDeleteDate,
            ExtendClearanceByXMonths: ExtendClearanceByXMonths,
            ExtendLoginCreds: ExtendLoginCreds,
            FscScreeningsExporting: FscScreeningsExporting,
            FvmRequestAcceptedAfterAppeal: FvmRequestAcceptedAfterAppeal,
            FvmRequestAcceptedWithLimitationAfterAppeal: FvmRequestAcceptedWithLimitationAfterAppeal,
            FvmRequestRefusedAfterAppeal: FvmRequestRefusedAfterAppeal,
            FVMSavePhase1: FVMSavePhase1,
            FVMSavePhase2: FVMSavePhase2,
            GenerateBVLPdf: GenerateBVLPdf,
            GetAction: GetAction,
            GetActions: GetActions,
            GetActiveWebinarEventItemsByLanguage: GetActiveWebinarEventItemsByLanguage,
            GetAgendasByFilter: GetAgendasByFilter,
            GetAllCodesByLanguage: GetAllCodesByLanguage,
            GetAllDossierComments: GetAllDossierComments,
            GetAllNewsItems: GetAllNewsItems,
            GetAllPersonsWithValidClearance: GetAllPersonsWithValidClearance,
            GetAllReports: GetAllReports,
            GetAllRequestComments: GetAllRequestComments,
            GetAllScreeningRemarksByFvm: GetAllScreeningRemarksByFvm,
            GetAllScreeningsForFvmRequest: GetAllScreeningsForFvmRequest,
            GetAllSoUsersByDossierOrganisationId: GetAllSoUsersByDossierOrganisationId,
            GetAllSubContractors: GetAllSubContractors,
            GetAllTranslations: GetAllTranslations,
            GetAppointSecurityOfficerDocument: GetAppointSecurityOfficerDocument,
            GetAssistOutLettersForRequest: GetAssistOutLettersForRequest,
            GetAssistOutStopLetterForScreening: GetAssistOutStopLetterForScreening,
            GetAttachmentByPublicId: GetAttachmentByPublicId,
            GetBelgianScreeningPartners: GetBelgianScreeningPartners,
            GetBoardMembers: GetBoardMembers,
            GetBranches: GetBranches,
            GetBVL: GetBVL,
            GetCertificate: GetCertificate,
            GetCertifOutStopLetterForScreening: GetCertifOutStopLetterForScreening,
            GetClearanceOverviewPaged: GetClearanceOverviewPaged,
            GetClearancesBySo: GetClearancesBySo,
            GetClearancesExporting: GetClearancesExporting,
            GetClearanceVMByEmailOverview: GetClearanceVMByEmailOverview,
            GetContactFormTopicForEdit: GetContactFormTopicForEdit,
            GetContactFormTopicsOverviewPaged: GetContactFormTopicsOverviewPaged,
            GetCreditnoteAtt: GetCreditnoteAtt,
            GetDossierByKboNumber: GetDossierByKboNumber,
            GetDossierInformation: GetDossierInformation,
            GetDossierInvoices: GetDossierInvoices,
            GetDossierManagers: GetDossierManagers,
            GetDossiersExporting: GetDossiersExporting,
            GetDossiersWithoutAnnualReportExport: GetDossiersWithoutAnnualReportExport,
            GetExclusivityDocument: GetExclusivityDocument,
            GetExplanatoryNoteTerms: GetExplanatoryNoteTerms,
            GetFSCISDocument: GetFSCISDocument,
            GetFunctionalCode: GetFunctionalCode,
            GetFunctionalCodesPaged: GetFunctionalCodesPaged,
            GetFvmByScreeningId: GetFvmByScreeningId,
            GetFVMEdit: GetFVMEdit,
            GetFvmEditByScreeningId: GetFvmEditByScreeningId,
            GetFVMPhase1: GetFVMPhase1,
            GetFvmPhase1SignaturesByUser: GetFvmPhase1SignaturesByUser,
            GetFVMPhase2: GetFVMPhase2,
            GetFvmRequestResult: GetFvmRequestResult,
            GetFVMRequestsExporting: GetFVMRequestsExporting,
            GetFvmScreeningsToStop: GetFvmScreeningsToStop,
            GetHomologationJustifications: GetHomologationJustifications,
            GetInvalidSubcontractorJustifications: GetInvalidSubcontractorJustifications,
            GetInvoiceAddress: GetInvoiceAddress,
            GetInvoiceFee: GetInvoiceFee,
            GetInvoicePdf: GetInvoicePdf,
            GetInvoicesFeeByFilter: GetInvoicesFeeByFilter,
            GetIVMAcknowledgementModel: GetIVMAcknowledgementModel,
            GetIVMRequestPhase2: GetIVMRequestPhase2,
            GetIVMRequestPhase4: GetIVMRequestPhase4,
            GetIVMRequestPhase5: GetIVMRequestPhase5,
            GetIvmRequestResult: GetIvmRequestResult,
            GetIVMRequestsExporting: GetIVMRequestsExporting,
            GetIVMScreeningRemarks: GetIVMScreeningRemarks,
            GetIVMSecurityBriefingModel: GetIVMSecurityBriefingModel,
            GetLoggingByFilter: GetLoggingByFilter,
            GetLoggingTotalsByFilter: GetLoggingTotalsByFilter,
            GetMainContractorNameByKBONumber: GetMainContractorNameByKBONumber,
            GetManageUsersButtonStates: GetManageUsersButtonStates,
            GetNewIVMPhase1FromFVM: GetNewIVMPhase1FromFVM,
            GetNewsItemsByAppsAndRoles: GetNewsItemsByAppsAndRoles,
            GetNoAcknowledgementDocument: GetNoAcknowledgementDocument,
            GetNotifications: GetNotifications,
            GetNsaSecurityAwarenessBriefing: GetNsaSecurityAwarenessBriefing,
            GetOrganisationDossier: GetOrganisationDossier,
            GetOrganisationsByKboNumberOrName: GetOrganisationsByKboNumberOrName,
            GetOrganisationsToLinkSubContractor: GetOrganisationsToLinkSubContractor,
            GetOrganisationSubContractors: GetOrganisationSubContractors,
            GetParameter: GetParameter,
            GetPartner: GetPartner,
            GetPartnerByCodeAndType: GetPartnerByCodeAndType,
            GetPartnerCodes: GetPartnerCodes,
            GetPartners: GetPartners,
            GetPaymentMailSamples: GetPaymentMailSamples,
            GetPdfFiles: GetPdfFiles,
            GetPhaseFile: GetPhaseFile,
            GetPhaseFilesSetAccepted: GetPhaseFilesSetAccepted,
            GetPrivateTopicsInUserLanguage: GetPrivateTopicsInUserLanguage,
            GetPscBriefingData: GetPscBriefingData,
            GetPscisDocument: GetPscisDocument,
            GetPublicNewsItemsByApps: GetPublicNewsItemsByApps,
            GetRegistrationDocument: GetRegistrationDocument,
            GetRemarksForPscRequest: GetRemarksForPscRequest,
            GetReportById: GetReportById,
            GetReportByIdAndFilter: GetReportByIdAndFilter,
            GetRequestFvmPersonForCurrentUser: GetRequestFvmPersonForCurrentUser,
            GetRequestHistory: GetRequestHistory,
            GetRequestIvmsWithOngoingScreenings: GetRequestIvmsWithOngoingScreenings,
            GetResultLetterForRequestByPartner: GetResultLetterForRequestByPartner,
            GetScreeningAttachments: GetScreeningAttachments,
            GetScreeningGroupByFvmId: GetScreeningGroupByFvmId,
            GetScreeningsToStop: GetScreeningsToStop,
            GetSecurityOfficerApplicationDetail: GetSecurityOfficerApplicationDetail,
            GetSecurityOfficerApplications: GetSecurityOfficerApplications,
            GetSecurityOfficersAndBoardmembersByOrganisationId: GetSecurityOfficersAndBoardmembersByOrganisationId,
            GetSendToInvolvedWhenIvmIsCompletedMailBody: GetSendToInvolvedWhenIvmIsCompletedMailBody,
            GetSessionTrace: GetSessionTrace,
            GetStoppedScreenings: GetStoppedScreenings,
            GetSubContractorAlreadyExists: GetSubContractorAlreadyExists,
            GetSummaryForRelation: GetSummaryForRelation,
            GetTranslationPhrasesPaged: GetTranslationPhrasesPaged,
            GetTranslationsByLanguage: GetTranslationsByLanguage,
            GetUsersByRoleExporting: GetUsersByRoleExporting,
            GetUsersByRolePaged: GetUsersByRolePaged,
            GetVideoFiles: GetVideoFiles,
            GetVoDashboardInfo: GetVoDashboardInfo,
            GetWebinarEventItemOverviewByFilter: GetWebinarEventItemOverviewByFilter,
            GetWordTemplate: GetWordTemplate,
            GetWordTemplateFiles: GetWordTemplateFiles,
            GetWordTemplateTypes: GetWordTemplateTypes,
            InvalidateJustification: InvalidateJustification,
            InviteRelation: InviteRelation,
            IsDocumentNoAcknowledgementAlreadySigned: IsDocumentNoAcknowledgementAlreadySigned,
            IvmRequestAcceptedAfterAppeal: IvmRequestAcceptedAfterAppeal,
            IvmRequestAcceptedWithLimitationAfterAppeal: IvmRequestAcceptedWithLimitationAfterAppeal,
            IvmRequestRefusedAfterAppeal: IvmRequestRefusedAfterAppeal,
            ListFunctionalCodes: ListFunctionalCodes,
            LoadFromKBO: LoadFromKBO,
            MarkRequestAsRenewal: MarkRequestAsRenewal,
            MarkUserAsPreferredSo: MarkUserAsPreferredSo,
            ProceedWithStopDossier: ProceedWithStopDossier,
            ProcessAcceptTerms: ProcessAcceptTerms,
            PscRequestAdministrativelyRefusedAfterAppeal: PscRequestAdministrativelyRefusedAfterAppeal,
            RecallFVM: RecallFVM,
            RecallIvmByPublicIdAndScreeningId: RecallIvmByPublicIdAndScreeningId,
            RefuseStopPsc: RefuseStopPsc,
            RefuseTerms: RefuseTerms,
            RefuseVMByEmailRequest: RefuseVMByEmailRequest,
            RejectSecurityOfficerApplication: RejectSecurityOfficerApplication,
            RemoveFvmOnHold: RemoveFvmOnHold,
            RemoveJustification: RemoveJustification,
            RemoveSignaturesOnUpdateAfterInvitationWasSend: RemoveSignaturesOnUpdateAfterInvitationWasSend,
            ReopenIvmScreening: ReopenIvmScreening,
            ReopenScreeningById: ReopenScreeningById,
            ReopenScreenings: ReopenScreenings,
            ReplyOnNotification: ReplyOnNotification,
            RequestCreditNoteAndInvalidate: RequestCreditNoteAndInvalidate,
            RequestCreditNoteForInvoice: RequestCreditNoteForInvoice,
            RequestCreditNoteForInvoiceLine: RequestCreditNoteForInvoiceLine,
            ResendLoginCreds: ResendLoginCreds,
            ResetFvmPersonAction: ResetFvmPersonAction,
            ResetJustificationAction: ResetJustificationAction,
            ReturnFvmToSo: ReturnFvmToSo,
            ReturnIvmToSo: ReturnIvmToSo,
            RevokePersonSecurityClearance: RevokePersonSecurityClearance,
            SaveAction: SaveAction,
            SaveBaseRemark: SaveBaseRemark,
            SaveDossierComment: SaveDossierComment,
            SaveExternalSubscriberToEventItem: SaveExternalSubscriberToEventItem,
            SaveFscPersonRemark: SaveFscPersonRemark,
            SaveFunctionalCode: SaveFunctionalCode,
            SaveFvmEdit: SaveFvmEdit,
            SaveFvmPerson: SaveFvmPerson,
            SaveIvmRangeAction: SaveIvmRangeAction,
            SaveIvmRangeRemark: SaveIvmRangeRemark,
            SaveIVMRequestPhase2: SaveIVMRequestPhase2,
            SaveIVMRequestPhase4: SaveIVMRequestPhase4,
            SaveIVMRequestPhase5: SaveIVMRequestPhase5,
            SaveIVMScreeningRemark: SaveIVMScreeningRemark,
            SaveJustificationRemark: SaveJustificationRemark,
            SaveNoAcknowledgement: SaveNoAcknowledgement,
            SaveOrCreateTranslationPhrase: SaveOrCreateTranslationPhrase,
            SaveParameter: SaveParameter,
            SavePartner: SavePartner,
            SaveRequestComment: SaveRequestComment,
            SaveRequestRemark: SaveRequestRemark,
            SaveSecurityIncidentComment: SaveSecurityIncidentComment,
            SaveSubjectPersonRemark: SaveSubjectPersonRemark,
            ScreeningsExporting: ScreeningsExporting,
            SearchCreditNotes: SearchCreditNotes,
            SearchDossierPaged: SearchDossierPaged,
            SearchFVMRequests: SearchFVMRequests,
            SearchFvmScreeningsToStop: SearchFvmScreeningsToStop,
            SearchInvoices: SearchInvoices,
            SearchIVMRequests: SearchIVMRequests,
            SearchMyFvmScreening: SearchMyFvmScreening,
            SearchMyPagedScreenings: SearchMyPagedScreenings,
            SearchParameters: SearchParameters,
            SearchRegisteredCompanies: SearchRegisteredCompanies,
            SearchScreeningsPerOrganisation: SearchScreeningsPerOrganisation,
            SearchStateChangesToConfirm: SearchStateChangesToConfirm,
            SelectSigningBoardMember: SelectSigningBoardMember,
            SelectSigningSecurityOfficer: SelectSigningSecurityOfficer,
            SendAcceptedVMByEmailRequestToVo: SendAcceptedVMByEmailRequestToVo,
            SendAssistanceInResultLetter: SendAssistanceInResultLetter,
            SendClearanceDeactivationToNsa: SendClearanceDeactivationToNsa,
            SendFvmBackToPhase1: SendFvmBackToPhase1,
            SendFvmEditBackToSo: SendFvmEditBackToSo,
            SendFvmEditToNvo: SendFvmEditToNvo,
            SendFvmPhase1BackToSo: SendFvmPhase1BackToSo,
            SendFvmPhase1SignatureInvitationMail: SendFvmPhase1SignatureInvitationMail,
            SendFvmPhase1ToNvo: SendFvmPhase1ToNvo,
            SendFvmPhase2BackToSo: SendFvmPhase2BackToSo,
            SendFvmPhase2ToNvo: SendFvmPhase2ToNvo,
            SendInvestigationImpossibleEmail: SendInvestigationImpossibleEmail,
            SendInvitationToSignNoAcknowledgementDocument: SendInvitationToSignNoAcknowledgementDocument,
            SendInvitationToSignTemporaryNoAcknowledgementDocument: SendInvitationToSignTemporaryNoAcknowledgementDocument,
            SendIvmBackInvalidByCol: SendIvmBackInvalidByCol,
            SendIvmBackInvalidByNvo: SendIvmBackInvalidByNvo,
            SendIvmRequestBackToInvolved: SendIvmRequestBackToInvolved,
            SendMail: SendMail,
            SendNewsItemByPublicId: SendNewsItemByPublicId,
            SendNoAcknowledgementDocument: SendNoAcknowledgementDocument,
            SendReminderForInvoice: SendReminderForInvoice,
            SendReminderMailForAssistOutRequest: SendReminderMailForAssistOutRequest,
            SendReminderMailForCertifOutRequest: SendReminderMailForCertifOutRequest,
            SendStopScreeningToNsa: SendStopScreeningToNsa,
            SetActionCodeForPerson: SetActionCodeForPerson,
            SetExternalSubscriberAttendance: SetExternalSubscriberAttendance,
            SetForeignState: SetForeignState,
            SetFvmAppealed: SetFvmAppealed,
            SetFvmOnHold: SetFvmOnHold,
            SetFvmPersonNoAckJustificationsAndRemark: SetFvmPersonNoAckJustificationsAndRemark,
            SetFvmRequestBackToNsa: SetFvmRequestBackToNsa,
            SetFvmSignatureByUser: SetFvmSignatureByUser,
            SetIvmAppealed: SetIvmAppealed,
            SetIvmAppealedDecisionOutOfTerm: SetIvmAppealedDecisionOutOfTerm,
            SetIvmNeedsToBeInvoiced: SetIvmNeedsToBeInvoiced,
            SetIvmOnHold: SetIvmOnHold,
            SetIvmRequestBackToNsa: SetIvmRequestBackToNsa,
            SetIvmRequestDeleted: SetIvmRequestDeleted,
            SetPscRequestBackToSo: SetPscRequestBackToSo,
            SetReadStateOnNotification: SetReadStateOnNotification,
            SetRelatedCompanyExplanationAcceptedAndReason: SetRelatedCompanyExplanationAcceptedAndReason,
            SetRequireAdditionalDocuments: SetRequireAdditionalDocuments,
            SetSignedBvlsSeenBySo: SetSignedBvlsSeenBySo,
            SetSubscriberAttendance: SetSubscriberAttendance,
            StartForeignPartialScreeningForRequest: StartForeignPartialScreeningForRequest,
            StartFvmEdit: StartFvmEdit,
            StartFVMRenewal: StartFVMRenewal,
            StopFvmScreenings: StopFvmScreenings,
            StopPartialScreening: StopPartialScreening,
            StopScreenings: StopScreenings,
            StopSecurityOfficerApplication: StopSecurityOfficerApplication,
            SubmitIVMAcknowledgementSignature: SubmitIVMAcknowledgementSignature,
            SubmitIVMSecurityBriefingSignature: SubmitIVMSecurityBriefingSignature,
            SubmitPrivateContactFormToNvo: SubmitPrivateContactFormToNvo,
            SubmitRegistrationToNsa: SubmitRegistrationToNsa,
            SubmitRelationSignature: SubmitRelationSignature,
            SubscribeToEventItem: SubscribeToEventItem,
            SuspendPersonSecurityClearance: SuspendPersonSecurityClearance,
            UnblockDossier: UnblockDossier,
            UnsubscribeEventItem: UnsubscribeEventItem,
            UnsubscribeExternalSubscriber: UnsubscribeExternalSubscriber,
            UpdateBVL: UpdateBVL,
            UpdateDossierRemarks: UpdateDossierRemarks,
            UpdateForeignIVMClearancePdf: UpdateForeignIVMClearancePdf,
            UpdateGovernmentAddresses: UpdateGovernmentAddresses,
            UpdateImportedSecurityOfficer: UpdateImportedSecurityOfficer,
            UpdateOrganisationType: UpdateOrganisationType,
            UpdatePersonSecurityClearanceDate: UpdatePersonSecurityClearanceDate,
            UploadAnnualReport: UploadAnnualReport,
            UploadAttachmentsForRequest: UploadAttachmentsForRequest,
            UploadDossierCommentAttachment: UploadDossierCommentAttachment,
            UploadExcelResx: UploadExcelResx,
            UploadHabilBVL: UploadHabilBVL,
            UploadJustificationAttachment: UploadJustificationAttachment,
            UploadPaymentFile: UploadPaymentFile,
            UploadPdfFile: UploadPdfFile,
            UploadRequestCommentAttachment: UploadRequestCommentAttachment,
            UploadScreeningResults: UploadScreeningResults,
            UploadTemporaryNoAcknowledgementDocument: UploadTemporaryNoAcknowledgementDocument,
            UploadUpdateFiles: UploadUpdateFiles,
            UploadVideoFile: UploadVideoFile,
            UploadWordTemplate: UploadWordTemplate,
            WithdrawFvmAppeal: WithdrawFvmAppeal,
            WithdrawIvmAppeal: WithdrawIvmAppeal,

        };
    }

})();
